import { _ } from '@ngx-translate/core';
import { IReportCheckboxOption } from '@app/shared/interfaces/report-checkbox-option';
import { LoggerNoiseReportParametersControlKey } from '@app/main/leak-detection/enums/logger-noise-report-parameters-control-key.enum';

export const LOGGER_NOISE_REPORT_PARAMETERS_CHECKBOX_OPTIONS: IReportCheckboxOption<LoggerNoiseReportParametersControlKey>[] =
  [
    {
      controlKey: LoggerNoiseReportParametersControlKey.Map,
      labelKey: _(`@@ld-create-report-dialog__checkbox-map`),
    },
    {
      controlKey: LoggerNoiseReportParametersControlKey.StreetView,
      labelKey: _(`@@ld-create-report-dialog__checkbox-street-view`),
    },
    {
      controlKey: LoggerNoiseReportParametersControlKey.Histogram,
      labelKey: _(`@@leak-detection-histogram`),
    },
    {
      controlKey: LoggerNoiseReportParametersControlKey.SignalSpectrum,
      labelKey: _(`@@ld-create-report-dialog__checkbox-signal-spectrum`),
    },
    {
      controlKey: LoggerNoiseReportParametersControlKey.LeakScoreHistory,
      labelKey: _(`@@ld-create-report-dialog__checkbox-leak-score-history`),
    },
    {
      controlKey: LoggerNoiseReportParametersControlKey.NoiseLevelHistory,
      labelKey: _(`@@ld-create-report-dialog__checkbox-noise-level-history`),
    },
  ];
